import { useValuationStore } from '@/store/valuationStore'
import { deleteImageRecord } from '@/services/idbService'

/**
 * Clears form-recognizer (scan valuation report) photos from store + IDB.
 * Call only once leaving the form page is certain — loadClaimForEditing loads the
 * correct ones fresh on next Edit.
 */
export function clearFormRecognizerPhotos(): void {
  const stale = useValuationStore.getState().photos.filter((p) => p.blobSection === 'form-recognizer')
  if (stale.length === 0) return
  stale.forEach((p) => {
    URL.revokeObjectURL(p.blobUrl)
    deleteImageRecord(p.id).catch(() => {})
  })
  const staleIds = new Set(stale.map((p) => p.id))
  useValuationStore.setState((s) => ({ photos: s.photos.filter((p) => !staleIds.has(p.id)) }))
}
